/* eslint-disable no-use-before-define */
const DEFAULTS = {
  duration: 300,
  done: () => {},
};

let globalOptions = {};

const isAnimatingStyle = {
  transition: 'opacity ease 500ms',
};

const outStyle = {
  opacity: 0,
};

export default function fadeOut(el, options) {
  // eslint-disable-next-line no-param-reassign
  globalOptions = { ...DEFAULTS, ...options };
  isAnimatingStyle.transition = `opacity ${globalOptions.duration}ms ease`;
  animateOut(el);
}

function animateOut(el) {
  if (!el) {
    return;
  }

  el.addEventListener('transitionend', removeTransition);
  Object.assign(el.style, isAnimatingStyle);
  window.requestAnimationFrame(() => {
    Object.assign(el.style, outStyle);
  });
}

function removeTransition(e) {
  Object.assign(e.target.style, {
    transition: '',
    display: 'none',
  });
  e.target.removeEventListener('transitionend', removeTransition);
  globalOptions.done();
}
